import { Grid } from '@material-ui/core';
import React from 'react';
import { setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { styles as micrStyles } from './micr-processing-view-styles';
import { styles } from 'src/tendering/components/process-tender/tender-processing-view-styles';
import TenderGroupTitle from 'src/tendering/components/tender-group-title';
import { AppState, store } from 'src/common/redux/configure-store';
import TenderAmountDue from 'src/tendering/components/tender-amount-due';
import ManualEndorseMessage from './manual-endorse-message';
import { CheckEndorsementViewProps } from '../components/check-processing-types';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import { useSelector } from 'react-redux';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';

export const showManualEndorsement = (props: ManualEndorseProps): void => {
  setHomePage(<ManualEndorsement {...props} />, undefined);
};

const ManualEndorsement: React.FC<ManualEndorseProps> = (
  props: ManualEndorseProps,
): JSX.Element => {
  const classes = styles();
  const micrClasses = micrStyles();
  const trainingModeClasses = trainingModeStyles();
  const trainingMode = useSelector((state: AppState): boolean => state.posMode.trainingMode);
  const { amountDue } = props.screenData;
  return (
    <Grid
      item
      container
      direction='row'
      justifyContent='space-between'
      className={`fullHeight flexFull ${classes.viewContainer} ${
        trainingMode ? trainingModeClasses.trainingModeBackground : ''
      }`}
    >
      <Grid
        item
        container
        direction='row'
        justifyContent='space-between'
        className={classes.viewHeader}
      >
        <Grid item lg={9}>
          <TenderGroupTitle title={store.getState().tenderMenu.selectedTenderGroup?.name || ''} />
        </Grid>
        <Grid item>
          <TenderAmountDue amountDue={amountDue} align='right' />
        </Grid>
      </Grid>
      <Grid item container direction='row' className={micrClasses.pageContent}>
        <ManualEndorseMessage {...props} />
      </Grid>
      {trainingMode && (
        <TrainingModeWatermark
          dataTestId='action-window-training-mode-watermark'
          supplementalStyles={trainingModeClasses.trainingWaterMark}
        />
      )}
    </Grid>
  );
};

export default ManualEndorsement;

export interface ManualEndorseProps {
  tenderId: string;
  screenData: CheckEndorsementViewProps;
  onlyShowBack?: boolean;
  receiptData?: IReceipt[];
}
